import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Handles in-page anchor scrolling for React Router.
 * - If the URL has a hash (#diagnostic, #faq, …), scrolls to that element.
 *   Retries a few times to wait for the target section to be rendered.
 * - Otherwise, scrolls to the top on every route change.
 */
export default function ScrollToHash() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, behavior: "instant" });
      return;
    }
    const id = hash.replace(/^#/, "");
    let attempts = 0;
    const maxAttempts = 20;
    const tryScroll = () => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
      attempts += 1;
      if (attempts < maxAttempts) {
        setTimeout(tryScroll, 60);
      }
    };
    tryScroll();
  }, [pathname, hash]);

  return null;
}
